module.exports = __webpack_public_path__ + "img/fruit-quince-190x100.2315dbd6.jpg";